import { useEffect, useState } from "react";
import { useLenis } from "../components/LenisProvider"; // Adjust the import path
import { useNavigate, useLocation } from "react-router-dom";

// Define the type for galleryData keys
type ProjectName =
  | "Nakshatra Nagar"
  | "Star City"
  | "Star Park"
  | "BDGS"
  | "Sanctuary Resort";

// Define the type for galleryData
interface GalleryData {
  [key: string]: string[];
  "Nakshatra Nagar": string[];
  "Star City": string[];
  "Star Park": string[];
  BDGS: string[];
  "Sanctuary Resort": string[];
}

const galleryData: GalleryData = {
  "Nakshatra Nagar": [
    "\\assets\\imgs\\nakshtra-nagar\\1.webp",
    "\\assets\\imgs\\nakshtra-nagar\\2.webp",
    "\\assets\\imgs\\nakshtra-nagar\\3.webp",
    "\\assets\\imgs\\nakshtra-nagar\\4.webp",
    "\\assets\\imgs\\nakshtra-nagar\\5.webp",
    "\\assets\\imgs\\nakshtra-nagar\\6.webp",
    "\\assets\\imgs\\nakshtra-nagar\\0012.webp",
    "\\assets\\imgs\\nakshtra-nagar\\0036.webp",
    "\\assets\\imgs\\nakshtra-nagar\\0040.webp",
    "\\assets\\imgs\\nakshtra-nagar\\0052.webp",
    "\\assets\\imgs\\nakshtra-nagar\\054.webp",
    "\\assets\\imgs\\nakshtra-nagar\\0057.webp",
    "\\assets\\imgs\\nakshtra-nagar\\070.webp",
    "\\assets\\imgs\\nakshtra-nagar\\0071.webp",
    "\\assets\\imgs\\nakshtra-nagar\\0077.webp",
    "\\assets\\imgs\\nakshtra-nagar\\0099.webp",
    // "\\assets\\imgs\\nakshtra-nagar\\0106.webp",
    "\\assets\\imgs\\nakshtra-nagar\\10000.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_1756.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7570.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7576.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7580.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7585.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7589.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7598.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7603.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7605.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7625.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7648.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7654.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7669.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7698.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7708.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7729.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7737.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7750.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7757.webp",
    "\\assets\\imgs\\nakshtra-nagar\\IMG_7761.webp",
    "\\assets\\imgs\\nakshtra-nagar\\phase1.webp",
    "\\assets\\imgs\\nakshtra-nagar\\phase1a.webp",
    "\\assets\\imgs\\nakshtra-nagar\\phase1b.webp",
    "\\assets\\imgs\\nakshtra-nagar\\phase2.webp",
    "\\assets\\imgs\\nakshtra-nagar\\rahul_color_.webp",
    "\\assets\\imgs\\nakshtra-nagar\\starcity1.webp",
    "\\assets\\imgs\\nakshtra-nagar\\starcity2.webp",
    "\\assets\\imgs\\nakshtra-nagar\\starcity3.webp",
    "\\assets\\imgs\\nakshtra-nagar\\starcity4.webp",
  ],
  "Star City": [
    "\\assets\\imgs\\Projects\\StarCity\\starcity1.webp",
    "\\assets\\imgs\\Projects\\StarCity\\starcity2.webp",
    "\\assets\\imgs\\Projects\\StarCity\\starcity3.webp",
    "\\assets\\imgs\\Projects\\StarCity\\starcity4.webp",
  ],
  "Star Park": [
    "\\assets\\imgs\\Key Business\\a.webp",
    "\\assets\\imgs\\Key Business\\b.webp",
    "\\assets\\imgs\\Key Business\\c.webp",
    "\\assets\\imgs\\Key Business\\d.webp",
  ],
  BDGS: [
    "\\assets\\imgs\\brain-discovery\\1.webp",
    "\\assets\\imgs\\brain-discovery\\2.webp",
    "\\assets\\imgs\\brain-discovery\\3.webp",
    "\\assets\\imgs\\brain-discovery\\4.webp",
    "\\assets\\imgs\\brain-discovery\\5.webp",
    "\\assets\\imgs\\brain-discovery\\6.webp",
    "\\assets\\imgs\\brain-discovery\\7.webp",
    "\\assets\\imgs\\brain-discovery\\8.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.54_2289a469.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.54_fa2f1fea.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.55_14d7495b.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.55_e2a35c35.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.56_117d9663.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.56_801fa527.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.57_3e5cb44f.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.57_25ab208b.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.57_c0637bba.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.58_7a900a20.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.58_7d740b90.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.58_21589226.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.59_5fcac20b.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.59_0171b501.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.44.59_e541e2c6.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.45.00_1fa3a77e.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.45.00_6c7b64d1.webp",
    "\\assets\\imgs\\brain-discovery\\WhatsApp Image 2025-03-03 at 17.45.01_9e1bed25.webp",
  ],
  "Sanctuary Resort": [
    "\\assets\\imgs\\santuary-resort\\1.webp",
    "\\assets\\imgs\\santuary-resort\\2.webp",
    "\\assets\\imgs\\santuary-resort\\3.webp",
    "\\assets\\imgs\\santuary-resort\\4.webp",
    "\\assets\\imgs\\santuary-resort\\5.webp",
    "\\assets\\imgs\\santuary-resort\\6.webp",
    "\\assets\\imgs\\santuary-resort\\7.webp",
    "\\assets\\imgs\\santuary-resort\\8.webp",
    "\\assets\\imgs\\santuary-resort\\9.webp",
    "\\assets\\imgs\\santuary-resort\\10.webp",
    "\\assets\\imgs\\santuary-resort\\a.webp",
    "\\assets\\imgs\\santuary-resort\\b.webp",
    "\\assets\\imgs\\santuary-resort\\c.webp",
    "\\assets\\imgs\\santuary-resort\\d.webp",
    "\\assets\\imgs\\santuary-resort\\e.webp",
    "\\assets\\imgs\\santuary-resort\\f.webp",
    "\\assets\\imgs\\santuary-resort\\g.webp",
    "\\assets\\imgs\\santuary-resort\\h.webp",
    "\\assets\\imgs\\santuary-resort\\i.webp",
    "\\assets\\imgs\\santuary-resort\\j.webp",
    "\\assets\\imgs\\santuary-resort\\k.webp",
    "\\assets\\imgs\\santuary-resort\\l.webp",
    "\\assets\\imgs\\santuary-resort\\m.webp",
    "\\assets\\imgs\\santuary-resort\\n.webp",
    "\\assets\\imgs\\santuary-resort\\o.webp",
    "\\assets\\imgs\\santuary-resort\\p.webp",
    "\\assets\\imgs\\santuary-resort\\q.webp",
    "\\assets\\imgs\\santuary-resort\\r.webp",
    "\\assets\\imgs\\santuary-resort\\s.webp",
    "\\assets\\imgs\\santuary-resort\\t.webp",
    "\\assets\\imgs\\santuary-resort\\WhatsApp Image 2025-03-04 at 12.20.24_8f2e4281.webp",
    "\\assets\\imgs\\santuary-resort\\WhatsApp Image 2025-03-04 at 12.20.32_8e71eed8.webp",
    "\\assets\\imgs\\santuary-resort\\WhatsApp Image 2025-03-04 at 12.20.32_b6f2aafd.webp",
  ],
};

const Gallery: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get initial tab from URL query parameter or default to "Nakshatra Nagar"
  const queryParams = new URLSearchParams(location.search);
  const initialTab =
    (queryParams.get("tab") as ProjectName) || "Nakshatra Nagar";

  const [activeTab, setActiveTab] = useState<ProjectName>(
    galleryData[initialTab] ? initialTab : "Nakshatra Nagar",
  );
  const [visibleImages, setVisibleImages] = useState<boolean[]>(
    new Array(galleryData[initialTab].length).fill(false),
  );
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const lenis = useLenis();

  // Handle opening the image preview
  const openImagePreview = (image: string) => {
    setSelectedImage(image);
    document.body.style.overflow = "hidden";
    if (lenis) lenis.stop();
  };

  // Handle closing the image preview
  const closeImagePreview = () => {
    setSelectedImage(null);
    document.body.style.overflow = "";
    if (lenis) lenis.start();
  };

  // Handle tab change and update URL
  const handleTabChange = (tab: ProjectName) => {
    setActiveTab(tab);
    setVisibleImages(new Array(galleryData[tab].length).fill(false));
    // Update URL with the new tab
    navigate(`?tab=${encodeURIComponent(tab)}`, { replace: false });
  };

  useEffect(() => {
    if (!lenis) return;

    const handleScroll = () => {
      const imageElements = document.querySelectorAll(".gallery-image");
      const newVisibleImages = Array.from(imageElements).map((el) => {
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom >= 0;
      });
      setVisibleImages(newVisibleImages);
    };

    lenis.on("scroll", handleScroll);
    handleScroll();

    return () => {
      lenis.off("scroll", handleScroll);
      document.body.style.overflow = "";
    };
  }, [activeTab, lenis]);

  // Sync activeTab with URL changes (e.g., back/forward navigation)
  useEffect(() => {
    const queryTab = queryParams.get("tab") as ProjectName;
    if (queryTab && galleryData[queryTab] && queryTab !== activeTab) {
      setActiveTab(queryTab);
      setVisibleImages(new Array(galleryData[queryTab].length).fill(false));
    }
  }, [location.search]);

  return (
    <div className="min-h-screen" style={{ fontFamily: "Gambetta" }}>
      {/* Hero Section */}
      <section
        className="relative flex min-h-[75vh] w-full items-center justify-center"
        style={{
          backgroundImage: "url('/assets/imgs/GalleryBg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/30"></div>
        <h1
          style={{ fontFamily: "HistoryPro" }}
          className="animate-fade-in relative z-10 text-4xl font-bold text-white md:text-5xl"
        >
          Gallery
        </h1>
      </section>

      {/* Tabs Navigation */}
      <div className="sticky top-0 z-20 bg-white py-4 shadow-lg">
        <div className="mx-auto flex max-w-6xl flex-wrap justify-center gap-4 px-4">
          {Object.keys(galleryData).map((tab) => (
            <button
              key={tab}
              onClick={() => handleTabChange(tab as ProjectName)}
              className={`relative px-6 py-2 text-lg font-medium transition-all duration-300 ease-in-out focus:outline-none ${
                activeTab === tab
                  ? "text-[#1a4fa3] after:absolute after:bottom-0 after:left-0 after:h-1 after:w-full after:bg-[#1a4fa3]"
                  : "text-gray-600 hover:text-[#1a4fa3]"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* Gallery Section */}
      <main className="py-12">
        <div className="mx-auto min-h-screen w-[95vw] px-4">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {galleryData[activeTab].map((image, index) => (
              <div
                key={index}
                className={`gallery-image relative transform overflow-hidden rounded-lg shadow-xl transition-all duration-700 ease-in-out ${
                  visibleImages[index]
                    ? "translate-y-0 opacity-100"
                    : "translate-y-10 opacity-0"
                }`}
                onClick={() => openImagePreview(image)}
              >
                <img
                  src={image}
                  alt={`${activeTab} Image ${index + 1}`}
                  className="z-40 h-64 w-full object-cover transition-transform duration-700 ease-in-out hover:scale-110 hover:shadow-xl md:h-96"
                  loading="lazy"
                />
                {/* <div className="absolute inset-0 z-0 bg-black/20 opacity-0 transition-opacity duration-300 hover:opacity-100 focus:opacity-100"></div> */}
              </div>
            ))}
          </div>
        </div>
      </main>

      {/* Custom Image Preview */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/75 transition-opacity duration-300 ease-in-out"
          onClick={closeImagePreview}
        >
          <div
            className="relative transform transition-transform duration-300 ease-in-out"
            style={{
              transform: selectedImage ? "scale(1)" : "scale(0.95)",
              opacity: selectedImage ? 1 : 0,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage}
              alt="Full Size Preview"
              className="max-h-[90vh] max-w-[90vw] rounded-lg object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
